<template>
	<!-- 登录 -->
	<div class="login" >
		<div class="loginPC" :style="loginPCStyle" v-loading="loading" :element-loading-text="lodingText"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
			style="width: 100%">
			<div class="loginPC-content">
				<div class="loginPC-content-img"></div>
				<div class="loginPC-content-p" v-if="oneLogin == false">
					<div class="loginPC-content-p-text">飞砂走石云平台</div>
					<div class="loginPC-content-p-from">
						<div class="loginPC-content-p-from-name">
							<el-input placeholder="请输入账号" v-model="ueseinfo.name" maxlength="11" @input="accountBlur">
								<i slot="prefix" class="el-input__icon el-icon-user"></i>
							</el-input>
							<div class="loginPC-error-text">
								<span v-if="accountErr">请输入有效账号</span>
							</div>
						</div>
						<!-- <div class="loginPC-content-Period-from-check">
							<div class="loginPC-content-Period-from-check-l">
								<el-input :readonly='readonly' @focus='handlerIptClick' placeholder="验证码" oninput="value=value.replace(/[^\d]/g,'')" maxlength="6" v-model="ueseinfo.checkNum">
									<i slot="prefix" class="el-input__icon el-icon-circle-check"></i>
								</el-input>
							</div>
							<div class="loginPC-content-Period-from-check-r">
								<el-button type="primary" :disabled="checkDisable" @click="countdown">{{ checkText }}
								</el-button>
							</div>
						</div> -->
						<div class="loginPC-content-p-from-pas">
							<el-input placeholder="请输入密码" v-model="ueseinfo.password" type="password" maxlength="16">
								<i slot="prefix" class="el-input__icon el-icon-lock"></i>
							</el-input>
						</div>
						<div v-if="authorizecodeBoll" class="loginPC-content-p-from-pas">
							<el-input placeholder="请输入授权码" v-model="ueseinfo.authorizecode" type="password"
								maxlength="16">
								<i slot="prefix" class="el-input__icon el-icon-s-check"></i>
							</el-input>
						</div>
					</div>
					<!-- <el-button class="tabBut" type="text" @click="forgetClick">客户登录</el-button> -->
					<button class="loginPC-content-p-btn pulic_cursor"
						:class="isLogin ? '' : 'loginPC-content-p-btn-bgc'" @click="submit">
						登录
					</button>
					<div class="loginPC-content-p-bottom">
						<!-- <div class="loginPC-content-p-bottom-forget" @click="forgetClick">
              忘记密码?
            </div> -->
						<el-button style="padding: 0;font-size:1.042vw;" class="loginPC-content-p-bottom-forget"
							type="text" @click="forgetClick">忘记密码?</el-button>
						<div class="loginPC-content-p-bottom-remember" v-if="LoginMethodCode != 'YZM'">
							记住密码
							<el-switch v-model="switchvalue" @change="switchChange">
							</el-switch>
						</div>
					</div>
					<div class="download">
						<div>
							<img style="heigth: 100px; width: 100px"
								src="https://feishazoushi.cn/appImages/downCustomer.png" alt="" />
						</div>
						<div style="margin-top: 10px">
							<a>扫码下载</a>
							<a style="margin-left: 10px; margin-right: 10px">|</a>
							<a href="https://shashiwangluo.oss-cn-hangzhou.aliyuncs.com/customer.apk" style="color: #00aaff">点击下载</a>
						</div>
					</div>
				</div>
				<div class="loginPC-content-p loginPC-content-Period" v-if="oneLogin">
					<div class="loginPC-content-p-text">飞砂走石云平台</div>
					<div class="loginPC-content-Period-from">
						<div class="loginPC-content-Period-from-name">
							<el-input placeholder="请输入账号" v-model="oneUserInfo.name" maxlength="11"
								@blur="firstAccountBlur">
								<i slot="prefix" class="el-input__icon el-icon-user"></i>
							</el-input>
							<div class="loginPC-error-text">
								<span v-if="firstAccountErr">请输入有效账号</span>
							</div>
						</div>
						<div class="loginPC-content-Period-from-check">
							<div class="loginPC-content-Period-from-check-l" maxlength="6">
								<el-input placeholder="验证码" v-model="oneUserInfo.checkNum">
									<i slot="prefix" class="el-input__icon el-icon-circle-check"></i>
								</el-input>
							</div>
							<div class="loginPC-content-Period-from-check-r">
								<el-button type="primary" :disabled="checkDisable" @click="countdown">{{ checkText }}
								</el-button>
							</div>
						</div>
						<div class="loginPC-content-Period-from-pas">
							<el-form :model="oneUserInfo" status-icon :rules="rules" ref="oneUserInfo"
								label-width="100px" class="demo-ruleForm">
								<el-form-item prop="pass">
									<el-input type="password" placeholder="请设置密码" v-model="oneUserInfo.pass"
										autocomplete="off" maxlength="16">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
									<span class="loginPC-content-Period-from-pas-text">密码需包含字母、数字，长度不低于6位</span>
								</el-form-item>
								<el-form-item prop="checkPass">
									<el-input type="password" placeholder="请再次输入密码" v-model="oneUserInfo.checkPass"
										autocomplete="off" maxlength="16">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
								</el-form-item>
							</el-form>
						</div>
						<button class="loginPC-content-p-btn pulic_cursor"
							:class="oneIsLogin ? '' : 'loginPC-content-p-btn-bgc'" @click="submit">
							登录
						</button>
						<div class="loginPC-content-p-bottom">
							<!-- <div class="loginPC-content-p-bottom-forget"></div> -->
							<div class="loginPC-content-p-bottom-remember">
								记住密码
								<el-switch v-model="oneSwitchValue" @change="oneSwitchChange">
								</el-switch>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :visible.sync="forgetDigVisible" @close="forgetClose" width="35%">
				<div class="loginPC-forgetdiagl">
					<el-form :model="forgetUserInfo" status-icon :rules="forgetRules" ref="forgetUserInfo"
						label-width="150px" class="forgetDig-rules">
						<el-form-item label="请输入手机号:" prop="name">
							<el-input type="text" placeholder="请输入手机号" v-model="forgetUserInfo.name"
								@blur="forgetAccountBlur" maxlength="11"></el-input>
							<div class="loginPC-error-text" style="padding: 0 0 5px 0; font-size: 12px">
								<span v-if="forgetAccountErr">请输入有效账号</span>
							</div>
						</el-form-item>
						<el-form-item label="请输入验证码:" prop="checkNum">
							<div class="loginPC-forget-check">
								<div>
									<el-input type="text" placeholder="请输入6位数字" v-model="forgetUserInfo.checkNum"
										maxlength="6"></el-input>
								</div>
								<div>
									<el-button type="primary" :disabled="forgetCheckDisable" @click="forgetCountdown">
										{{ forgetCheckText }}
									</el-button>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="请输入新密码:" prop="pass">
							<el-input type="password" placeholder="密码为6-16位数字字母组合" v-model="forgetUserInfo.pass"
								autocomplete="off" maxlength="16"></el-input>
						</el-form-item>
						<el-form-item label="请确认新密码:" prop="checkPass">
							<el-input type="password" placeholder="请再次输入新密码" v-model="forgetUserInfo.checkPass"
								autocomplete="off" maxlength="16"></el-input>
						</el-form-item>
					</el-form>
					<div class="loginPC-forget-bottom">
						<button type="default" @click="upPassword">确认</button>
						<button type="default" @click="reset">重置</button>
					</div>
				</div>
			</el-dialog>
			
			
		</div>
		<div class="loginPC-copyright">
			<span>
				<a class="text-hover" href="https://beian.miit.gov.cn/" target="_blank" style="padding-right:30px;"><span style="padding-right:30px;">豫ICP备2021023431号</span><span>该版权技术由河南沙石网络科技有限公司支持</span></a>
			</span>
		</div>
		
	</div>

</template>
<script>
	export default {
		data() {
			var valPas = (rule, value, callback) => {
				//第一次登录两次密码校验
				var reg = new RegExp(
					/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
				);
				var isval = reg.test(value);
				if (value === "") {
					callback(new Error("请输入有效密码"));
				} else {
					if (!isval) {
						callback(new Error("请输入有效密码"));
					} else {
						if (this.oneUserInfo.checkPass !== "") {
							this.$refs.oneUserInfo.validateField("checkPass");
						}
						callback();
					}
				}
			};
			var checktValPas = (rule, value, callback) => {
				//第一次登录两次密码校验
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.oneUserInfo.pass) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			var forgetValPas = (rule, value, callback) => {
				//修改两次密码校验
				var reg = new RegExp(
					/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
				);
				var isval = reg.test(value);
				if (value === "" && isval == false) {
					callback(new Error("请输入有效密码"));
				} else {
					if (!isval) {
						callback(new Error("请输入有效密码"));
					} else {
						if (this.forgetUserInfo.checkPass !== "") {
							this.$refs.forgetUserInfo.validateField("checkPass");
						}
						callback();
					}
				}
			};
			var forgetChecktValPas = (rule, value, callback) => {
				//修改两次密码校验
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.forgetUserInfo.pass) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			return {
				loginPCStyle: "",
				input4: "",
				switchvalue: false,
				readonly: true,
				ueseinfo: {
					name: "",
					password: "",
					checkNum: '',
				},
				oneUserInfo: {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
					authorizecode: "",
				},
				oneLogin: false, //是否为第一次登录
				authorizecodeBoll: false, //是否需要授权码
				oneSwitchValue: false,
				rules: {
					pass: [{
						validator: valPas,
						trigger: "blur"
					}],
					checkPass: [{
						validator: checktValPas,
						trigger: "blur"
					}],
				},
				checkDisable: false,
				checkText: "获取验证码",
				countdownNum: 60,
				forgetDigVisible: false,
				forgetUserInfo: {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
				},
				forgetRules: {
					pass: [{
						validator: forgetValPas,
						trigger: "blur"
					}],
					checkPass: [{
						validator: forgetChecktValPas,
						trigger: "blur"
					}],
				},
				forgetCheckDisable: false,
				forgetCheckText: "获取验证码",
				forgetCountdownNum: 60,
				loading: false,
				lodingText: "登录中...",
				accountErr: false,
				firstAccountErr: false,
				forgetAccountErr: false,
				isPhone: true,
				LoginMethodCode: "", //登录方式
				// 验证码登录
				MethodVerificationCode: "", //验证码
				checkDisableMethod: false,
				MethodDownNum: 60,
				MethodVerificationText: "获取验证码",
			};
		},
		computed: {
			isLogin() {
				//登录按钮
				if (
					this.ueseinfo.name.trim().length > 0 &&
					this.ueseinfo.password.trim().length > 0

				) {
					return true;
				} else {
					return false;
				}
			},
			isLoginMethod() {
				//验证码登录按钮
				if (
					this.ueseinfo.name.trim().length > 0 &&
					this.MethodVerificationCode.trim().length > 0
				) {
					return true;
				} else {
					return false;
				}
			},
			oneIsLogin() {
				//第一次登录按钮
				if (
					this.oneUserInfo.name.trim().length > 0 &&
					this.oneUserInfo.pass.trim().length > 0 &&
					this.oneUserInfo.checkPass.trim().length > 0 &&
					this.oneUserInfo.checkNum.trim().length > 0
				) {
					return true;
				} else {
					return false;
				}
			},
		},
		created() {
			let _self = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key == 13 || key == 108) {
					if (_self.$route.path == "/Login") {
						_self.submit();
					}
				}
				if (key == 32) {
					window.event.returnValue = false;
				}
			};
		},
		mounted() {
			sessionStorage.clear();
			this.$store.commit("setUser", "");
			this.$store.commit("setNavHistoy", "");
			this.$store.commit("setSole", "");
			this.$store.commit("upEditableTabs", []);
			this.$store.commit("setHistTabsValue", "");
			var windowH = window.innerHeight - 30;
			this.loginPCStyle = `height:${windowH}px`;
			this.getCookie();
			// console.log(this.$VERSION)
		},
		methods: {
			//去除浏览器账号与密码自动填充
			handlerIptClick() {
				this.readonly = false;
			},
			MethodDown() {
				//验证码登录--倒计时
				if (/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name)) {
					this.checkDisableMethod = true;
					this.MethodDownNum--;
					this.MethodVerificationText = `${this.MethodDownNum}后重新获取`;
					var time = setInterval(() => {
						if (this.MethodDownNum == 0) {
							clearInterval(time);
							this.MethodDownNum = 60;
							this.MethodVerificationText = "获取验证码";
							this.checkDisableMethod = false;
							return;
						} else {
							this.MethodDownNum--;
							var num =
								this.MethodDownNum < 10 ?
								"0" + this.MethodDownNum :
								this.MethodDownNum;
							this.MethodVerificationText = `${num}后重新获取`;
						}
					}, 1000);
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.ueseinfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			countdown() {
				//倒计时
				// console.log(this.ueseinfo.name)
				if (/^[1][3-9][0-9]{9}$/.test(this.oneUserInfo.name)) {
					this.checkDisable = true;
					this.countdownNum--;
					this.checkText = `${this.countdownNum}后重新获取`;
					var time = setInterval(() => {
						if (this.countdownNum == 0) {
							clearInterval(time);
							this.countdownNum = 60;
							this.checkText = "获取验证码";
							this.checkDisable = false;
							return;
						} else {
							this.countdownNum--;
							var num =
								this.countdownNum < 10 ?
								"0" + this.countdownNum :
								this.countdownNum;
							this.checkText = `${num}后重新获取`;
						}
					}, 1000);
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.oneUserInfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			forgetCountdown() {
				//忘记密码倒计时
				if (/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					this.forgetCheckDisable = true;
					this.forgetCountdownNum--;
					this.forgetCheckText = `${this.forgetCountdownNum}后重新获取`;
					var time = setInterval(() => {
						if (this.forgetCountdownNum == 0) {
							clearInterval(time);
							this.forgetCountdownNum = 60;
							this.forgetCheckText = "获取验证码";
							this.forgetCheckDisable = false;
							return;
						} else {
							this.forgetCountdownNum--;
							var num =
								this.forgetCountdownNum < 10 ?
								"0" + this.forgetCountdownNum :
								this.forgetCountdownNum;
							this.forgetCheckText = `${num}后重新获取`;
						}
					}, 1000);
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.forgetUserInfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			accountBlur() {
				//校验账号
				var index = this.ueseinfo.name.indexOf(`xst${new Date().getFullYear()}`);
				if (index != -1) return;
				if (!/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name)) {
					this.accountErr = true;
					var that = this;
					setTimeout(function() {
						that.accountErr = false;
					}, 3000);
				} else {
					// this.loading=true
					this.isFirstLogin();
				}
			},
			firstAccountBlur() {
				//第一次登录校验账号
				if (!/^[1][3-9][0-9]{9}$/.test(this.oneUserInfo.name)) {
					this.firstAccountErr = true;
					var that = this;
					setTimeout(function() {
						that.firstAccountErr = false;
					}, 3000);
				}
				if (this.oneUserInfo.name.length == 0) {
					this.oneLogin = false;
					this.isPhone = false;
					this.ueseinfo = {
						name: "",
						password: "",
					};
				}
			},
			forgetAccountBlur() {
				//修改登录校验账号
				if (!/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					this.forgetAccountErr = true;
					var that = this;
					setTimeout(function() {
						that.forgetAccountErr = false;
					}, 3000);
				}
			},
			forgetClick() {
				//忘记密码
				this.forgetDigVisible = !this.forgetDigVisible;
			},
			forgetClose() {
				//忘记密码初始化校验
				this.$refs.forgetUserInfo.resetFields();
				this.ueseinfo = {
					name: "",
					password: "",
				};
				this.isLogin == false;
			},
			switchChange(e) {
				//设置cookie
				let self = this;
				if (e == true) {
					//传入账号名，密码，和保存天数3个参数
					self.setCookie(self.ueseinfo.name, self.ueseinfo.password, 9999999);
				} else {
					//清空Cookie
					self.clearCookie();
				}
			},
			oneSwitchChange(e) {
				//设置cookie
				let self = this;
				if (e == true) {
					//传入账号名，密码，和保存天数3个参数
					self.setCookie(
						self.oneUserInfo.name,
						self.oneUserInfo.checkPass,
						9999999
					);
				} else {
					//清空Cookie
					self.clearCookie();
				}
			},
			setCookie(c_name, c_pwd, exdays) {
				//保存cookie
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			getCookie() {
				//读取cookie
				if (document.cookie.length > 0) {
					this.switchvalue = true;
					this.isPhone = true;
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "userName") {
							this.ueseinfo.name = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.ueseinfo.password = arr2[1];
						}
					}
				}
			},
			clearCookie() {
				//清除cookie
				this.setCookie("userName", "", -1); //修改2值都为空，天数为负1天就好了
				this.setCookie("userPwd", "", -1); //修改2值都为空，天数为负1天就好了
			},
			reset() {
				//忘记密码重置
				this.$refs.forgetUserInfo.resetFields();
				this.forgetUserInfo = {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
				};
			},
			error(str) {
				//错误提示
				this.$message.error(str);
			},
			submit() {
				//正常登陆
				if (this.oneLogin) {
					if (!this.oneIsLogin) return this.$message.error("请完善登录信息");
					if (this.oneUserInfo.name.trim().length != 0) {
						if (/^\d{6}$/.test(this.oneUserInfo.checkNum)) {
							this.$refs.oneUserInfo.validate((valid) => {
								if (valid) {
									this.loginQuery();
								} else {
									var reg = new RegExp(
										/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
									);
									if (!reg.test(this.oneUserInfo.pass))
										return this.$message.error("请输入有效密码");
									if (!reg.test(this.oneUserInfo.checkPass))
										return this.$message.error("请输入有效密码");
									this.$message.error("两次密码不一致，请重新输入");
								}
							});
						} else {
							this.$message.error("请输入六位有效验证码");
						}
					} else {
						this.$message.error("请输入有效手机号");
					}
				} else {
					if (this.isLogin == false) return this.$message.error("请完善登录信息");
					var index = this.ueseinfo.name.indexOf(
						`xst${new Date().getFullYear()}`
					);
					if (index == -1) {
						if (!/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name))
							return this.$message.error("请输入有效手机号");
						if (!this.isPhone) return this.$message.error("该用户不存在！");
					}
					if (this.ueseinfo.password.trim().length < 6)
						return this.$message.error("请输入有效密码");
					this.loginQuery();
				}
			},
			loginQuery() {
				// this.isFirstLogin()
				var url = "/user/login";
				this.loading = true;
				if (this.oneLogin) {
					var data = {
						PERTB005CA03: this.oneUserInfo.name,
						PERTB005CA01: this.oneUserInfo.checkPass,
						flag: true,
						PERTB006CA00: this.oneUserInfo.checkNum,
					};
				} else {
					var data = {
						PERTB005CA03: this.ueseinfo.name,
						PERTB005CA01: this.ueseinfo.password,
						authorizecode: this.ueseinfo.authorizecode,
						flag: false,
					};
				}

				this.axios
					.post(url, data)
					.then((res) => {
						console.log(res);
						
						// console.log(res, '登录成功');
						setTimeout(() => {
							this.loading = false;
						}, 500);
						if (res.data.code == 200) {
							this.$store.commit("setUser", res.data.data);
							// console.log(res.data.data)
							sessionStorage.setItem("token", res.data.data.token);
							if (this.switchvalue) {
								this.setCookie(
									this.ueseinfo.name,
									this.ueseinfo.password,
									9999999
								);
							}
							this.$router.push("/Home");
							this.$message.success(res.data.message)

						}
						if (res.data.code === 500) {
							this.authorizecodeBoll = true
							this.$message.error(res.data.message);

						} else {
							console.log(1)
							// this.$message.success(res.data.message);
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},
			isFirstLogin() {
				//校验是否为第一次登录
				var url = `/system/checkPhone/${this.ueseinfo.name}`;
				this.axios
					.get(url)
					.then((res) => {
						// console.log(res)
						// this.loading=false
						console.log(res.data.data)
						if (res.data.code == 202) {
							this.oneLogin = true;
							this.oneUserInfo.name = this.ueseinfo.name;
							this.$message.error(res.data.message);
						} else if (res.data.data == 1) {
							this.authorizecodeBoll = true
							this.$message.error('请输入授权码');
						} else if (res.data.data == 0) {
							this.authorizecodeBoll = false
							// this.$message.error('请输入授权码');
						} else if (res.data.code == 203) {
							this.isPhone = true;
						} else if (res.data.code == 201) {
							this.isPhone = false;
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},
			upPassword() {
				//忘记密码
				if (/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					if (/^\d{6}$/.test(this.forgetUserInfo.checkNum)) {
						this.$refs.forgetUserInfo.validate((valid) => {
							if (valid) {
								let loading = this.$loading({
									lock: true,
									text: "请求中...",
									spinner: "el-icon-loading",
									background: "rgba(0, 0, 0, 0.5)",
								});
								var url = "/system/updatepassword";
								var data = {
									username: this.forgetUserInfo.name,
									password: this.forgetUserInfo.checkPass,
									PERTB006CA00: this.forgetUserInfo.checkNum,
								};
								this.axios
									.post(url, data)
									.then((res) => {
										// console.log(res)
										setTimeout(() => {
											loading.close();
										}, 300);
										if (res.data.code == 200) {
											this.ueseinfo = {
												name: "",
												password: "",
											};
											this.isLogin == false;
											this.forgetDigVisible = !this.forgetDigVisible;
											this.$message.success("修改成功，请重新登陆。");
										} else {
											this.$message.error(res.data.message);
										}
									})
									.catch(() => {
										loading.close();
									});
							} else {
								var reg = new RegExp(
									/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
								);
								if (!reg.test(this.forgetUserInfo.pass))
									return this.$message.error("请输入有效密码");
								if (!reg.test(this.forgetUserInfo.checkPass))
									return this.$message.error("请输入有效密码");
								this.$message.error("两次密码不一致，请重新输入");
							}
						});
					} else {
						this.$message.error("请输入有效验证码");
					}
				} else {
					this.$message.error("请输入有效账号");
				}
			},
		},
	};
</script>
<style scoped>
	.download {
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: center;
		margin-top: 40px;
	}

	a {
		text-decoration: none;
		margin-top: 10px;
	}

	.loginPC {
		padding: 115px 125px;
		background: url(../../assets/images/login/loginBGI.png) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
	}

	.loginPC-error-text {
		height: 10px;
		padding-top: 5px;
		font-size: 16px;
		color: #f56c6c;
	}

	.loginPC-content {
		position: relative;
		top: -20px;
		display: flex;
		width: 100%;
		/* height: 100%; */
		overflow: hidden;
		box-sizing: border-box;
	}

	.loginPC-content-img {
		flex: 2.5;
		height: 100%;
		/* background: url(../../assets/images/login/loginbanner.jpg) no-repeat; */
		background-size: 100% 100%;
	}

	.loginPC-content-p {
		flex: 1;
		height: 100%;
		padding: 80px 60px 100px 60px;
		background-color: #fff;
		box-sizing: border-box;
	}

	.loginPC-content-p-text {
		text-align: center;
		font-size: 50px;
		color: #00aaff;
		margin-bottom: 70px;
	}

	.loginPC-content-p-from {
		/* width: 480px; */
		margin: auto;
	}

	.loginPC-content-p-from-name {
		padding-bottom: 41px;
		box-sizing: border-box;
	}

	.loginPC-content-p-from-pas,
	.loginPC-content-p-from-padding {
		padding-bottom: 30px;
		box-sizing: border-box;
	}

	.loginPC-content-p-from-padding {
		margin-bottom: 0 !important;
	}

	.loginPC-content-p-btn {
		display: block;
		width: 480px;
		height: 56px;
		line-height: 56px;
		margin: auto;
		font-size: 29px;
		text-align: center;
		color: #fff;
		background: rgba(0, 170, 255, 1);
		border-radius: 10px;
		border: none;
	}

	.loginPC-content-p-btn-bgc {
		background: rgba(0, 170, 255, 0.6);
	}

	.loginPC-content-p-btn:active {
		background-color: rgba(0, 170, 255, 0.3);
		border: none;
		outline: none;
	}

	.loginPC-content-p-bottom {
		width: 480px;
		margin: auto;
		display: flex;
		justify-content: space-between;
		margin-top: 19px;
		font-size: 20px;
		color: #666;
	}

	.loginPC-content-p-bottom-forget {
		/* color: #00aaff; */
	}

	.loginPC-content-Period {
		padding: 60px 60px 80px 60px;
		box-sizing: border-box;
	}

	.loginPC-content-Period-from {
		/* width: 480px; */
		margin: auto;
	}

	.loginPC-content-Period-from-check {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.loginPC-content-Period-from-check-l {
		flex: 1;
	}

	.loginPC-content-Period-from-check-r {
		flex: 0.3;
		padding-left: 20px;
		text-align: right;
	}

	.loginPC-content-Period-from-pas-text {
		display: block;
		padding-top: 5px;
		font-size: 16px;
		color: #999999;
		line-height: 15px;
	}

	.loginPC-content-Period-from-name {
		margin-bottom: 14px;
	}

	.loginPC-content-Period-from-pas {
		margin-bottom: 51px;
	}

	.forgetDig-rules {
		text-align: left;
	}

	.loginPC-forget-check {
		display: flex;
		justify-content: space-between;
	}

	.loginPC-forget-check>div:last-child {
		padding-left: 20px;
	}

	.loginPC-forget-bottom {
		padding: 40px 60px 20px;
		text-align: center;
	}

	.loginPC-forget-bottom button {
		width: 96px;
		height: 36px;
		cursor: pointer;
		color: #fff;
		font-size: 16px;
		background-color: #1aa0ff;
	}

	.loginPC-forget-bottom button:last-child {
		background-color: #feb419;
		margin-left: 40px;
	}

	.loginPC-forget-btn {
		height: 56px;
		line-height: 56px;
		background-color: rgba(0, 170, 255, 1);
		text-align: center;
		color: #fff;
		font-size: 29px;
		border-radius: 28px;
	}

	.loginPC-forget-btn:active {
		background-color: rgba(0, 170, 255, 0.3);
	}

	.loginPC-copyright {
		position: fixed;
		bottom: 0;
		width: 100%;
		/* line-height: 30px; */
		padding-bottom: 10px;
		text-align: center;
		font-size: 13px;
		color: #999;
	}


	.tabBut {
		padding: 0;
		padding-bottom: 20px;
		font-size: 1.042vw;
	}
	
	.text-hover {
	  color: #999; /* 默认颜色 */
	  transition: color 0.3s; /* 可选的颜色过渡效果 */
	}
	 
	.text-hover:hover {
	  color: #000; /* 鼠标移入后的颜色 */
	  /* background-color: yellow; */
	}
</style>
